import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSelfOrder(params) {
	return client.get("api/self-order/data", {
		params: params,
	});
}

function getProductWarehouse(params) {
	return client.get("api/self-order/data_product_warehouse", {
		params: params,
	});
}

function getSelfOrderDiscount(params) {
	return client.get("api/options/self_order_discount", {
		params: params,
	});
}

function saveProductSelfOrder(params) {
	return client.post("api/self-order/save_product_self_order", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}
function saveDiscountSelfOrder(params) {
	return client.post("api/self-order/save_self_order_discount", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}


export default {
	getSelfOrder,
	getProductWarehouse,
	getSelfOrderDiscount,
	saveProductSelfOrder,
	saveDiscountSelfOrder
};
